module.exports = __webpack_public_path__ + "static/img/sold-out-download.b0690489.png";